import { ChangeEvent, FC, InputHTMLAttributes, useMemo, useRef } from 'react'
import styled, { css } from 'styled-components'

interface CustomCheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'className'> {
  label?: string
  checked?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  error?: string
  disabled?: boolean
  name?: string
  id?: string
}

const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  margin-right: 8px;
    width: 24px;
  height: 24px;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

const Label = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  font-size: 15px;
  line-height: 20px;
`

const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
`

const CustomCheckboxBox = styled.span<{checked?: boolean, error?: boolean}>`
  position: relative;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border: 1px solid #909090;
  border-radius: 3px;
  transition: all 0.15s ease;
  background-color: transparent;

  ${({ checked }) => checked ? css`
    svg path {
      fill: ${({ theme }) => theme.projectEdit.btns.age.icon.color};
    }
  ` : null};
`

export const CustomCheckbox: FC<CustomCheckboxProps> = (props) => {
  const checkboxRef = useRef(null)
  const isChecked = props.checked ?? !!props.value

  return (
    <Wrapper>
      <Label>
        <HiddenInput
            ref={checkboxRef}
            type="checkbox"
            {...props}
            checked={isChecked}
            onChange={props?.onChange}
        />
 
        <CustomCheckboxBox checked={isChecked}>
            {isChecked && (
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z" fill="#151514"/>
                        </svg>
            )}
        </CustomCheckboxBox>
      </Label>
    </Wrapper>
  )
}import { ChangeEvent, FC, InputHTMLAttributes, useMemo, useRef } from 'react'
import styled, { css } from 'styled-components'

interface CustomCheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'className'> {
  label?: string
  checked?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  error?: string
  disabled?: boolean
  name?: string
  id?: string
}

const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  margin-right: 8px;
    width: 24px;
  height: 24px;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

const Label = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  font-size: 15px;
  line-height: 20px;
`

const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
`

const CustomCheckboxBox = styled.span<{checked?: boolean, error?: boolean}>`
  position: relative;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border: 1px solid #909090;
  border-radius: 3px;
  transition: all 0.15s ease;
  background-color: transparent;

  ${({ checked }) => checked ? css`
    svg path {
      fill: ${({ theme }) => theme.projectEdit.btns.age.icon.color};
    }
  ` : null};
`

export const CustomCheckbox: FC<CustomCheckboxProps> = (props) => {
  const checkboxRef = useRef(null)
  const isChecked = props.checked ?? !!props.value

  return (
    <Wrapper>
      <Label>
        <HiddenInput
            ref={checkboxRef}
            type="checkbox"
            {...props}
            checked={isChecked}
            onChange={props?.onChange}
        />
 
        <CustomCheckboxBox checked={isChecked}>
            {isChecked && (
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z" fill="#151514"/>
                        </svg>
            )}
        </CustomCheckboxBox>
      </Label>
    </Wrapper>
  )
}